<div class="player-overlay" (click)="closed.emit()">
  <div class="player-modal" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">

    <div class="player-header">
      <div class="player-heading">
        <div class="player-kicker" *ngIf="moduleTitle">{{ 'ASSISTANCE.MODULE' | translate }} · {{ moduleTitle }}</div>
        <h2 class="player-title"><span *ngIf="index >= 0">{{ index + 1 }}. </span>{{ resource.title }}</h2>
      </div>
      <button class="player-close" type="button" (click)="closed.emit()" [attr.aria-label]="'ACTIONS.CLOSE' | translate">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="player-body" [ngSwitch]="display">
      <!-- Vidéo hébergée : bridée. Elle garde ses scripts, son origine, le plein
           écran et ses liens vers l'hébergeur, mais ne navigue plus l'application.
           Le sandbox est statique : Angular refuse de le lier. -->
      <iframe *ngSwitchCase="'embed'" class="player-iframe" [src]="frameUrl" [title]="resource.title"
              sandbox="allow-scripts allow-same-origin allow-forms allow-presentation allow-popups allow-popups-to-escape-sandbox"
              allow="autoplay; encrypted-media; picture-in-picture; fullscreen"></iframe>

      <!-- PDF signé par l'API, servi en application/pdf : pas de sandbox, Chrome
           n'ouvre pas sa visionneuse dans un cadre bridé. -->
      <iframe *ngSwitchCase="'pdf'" class="player-iframe" [src]="frameUrl" [title]="resource.title"></iframe>

      <video *ngSwitchCase="'video'" class="player-video" [src]="mediaUrl"
             controls autoplay controlsList="nodownload"></video>

      <img *ngSwitchCase="'image'" class="player-image" [src]="mediaUrl" [alt]="resource.title">

      <div *ngSwitchDefault class="player-fallback">
        <div class="player-fallback-info">
          <i [class]="icon + ' player-fallback-icon'"></i>
          <p *ngIf="resource.fileName">{{ resource.fileName }}</p>
          <a *ngIf="linkUrl" [href]="linkUrl" target="_blank" rel="noopener noreferrer">{{ linkUrl }}</a>
        </div>
      </div>
    </div>

    <div class="player-footer">
      <p class="player-desc">{{ resource.description }}</p>
      <div class="player-actions">
        <button *ngIf="resource.hasFile" class="player-btn player-btn--ghost" type="button" (click)="download.emit(resource)">
          <i class="fa-solid fa-download"></i> {{ 'ASSISTANCE.DOWNLOAD' | translate }}
        </button>
        <a *ngIf="linkUrl" class="player-btn player-btn--ghost" [href]="linkUrl" target="_blank" rel="noopener noreferrer">
          <i class="fa-solid fa-arrow-up-right-from-square"></i> {{ 'ASSISTANCE.OPEN_LINK' | translate }}
        </a>

        <ng-container *ngIf="series.length > 1 && index >= 0">
          <button class="player-btn player-btn--ghost player-btn--prev" type="button"
                  [disabled]="!previous" (click)="navigate.emit(previous!)">
            <i class="fa-solid fa-chevron-left player-dir"></i> {{ 'ASSISTANCE.PREVIOUS' | translate }}
          </button>
          <span class="player-pos">{{ index + 1 }} / {{ series.length }}</span>
          <button class="player-btn player-btn--next" type="button"
                  [disabled]="!next" (click)="navigate.emit(next!)">
            {{ 'ASSISTANCE.NEXT' | translate }} <i class="fa-solid fa-chevron-right player-dir"></i>
          </button>
        </ng-container>
      </div>
    </div>

  </div>
</div>
